import React from "react";
import { RiDeleteBinLine } from "react-icons/ri";

export default function DeleteReplyModal(props) {
  let { onDelete, onClose } = props;

  return (
    <>
      <div className="fixed z-50 inset-0 flex items-center justify-center bg-black/60">
        <div className="p-4 max-w-xl w-full">
          <div className="shadow w-full rounded-lg bg-white p-8">
            <div className="py-4 p-6 space-y-4 flex items-center justify-center w-full">
              <div className="text-center space-y-4 w-full mx-auto">
                <div className="rounded-full p-4 bg-[#F44336]/15 text-[#F44336] inline-flex items-center justify-center cursor-pointer">
                  <RiDeleteBinLine className="h-7 w-7" />
                </div>
                <h2 className="text-lg md:text-xl font-semibold tracking-wide text-[#212121]">Are you sure delete this reply?</h2>
                <p className="text-base font-medium text-[#212121]/70">Once you delete this reply, you won't be able to revert this.</p>
                <div className="flex items-center justify-center pt-4 space-x-4">
                  <button onClick={() => onClose(false)} className="text-[#212121] w-full py-2 px-6 rounded-md uppercase border border-[#cccccc]">Cancel</button>
                  <button onClick={() => onDelete()} className="w-full bg-[#EF5350] text-white py-2 px-6 rounded-md uppercase">Yes, delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
